export default __webpack_public_path__ + "static/media/pantheon-logo-white.68b9dadb.svg";